import { useEffect, useState } from 'react';

import { slugify } from '../utils/slugify';

const addIdsToH2 = (rawContent: string) => {
  const doc = new DOMParser().parseFromString(rawContent, 'text/html');
  const h2Tags = doc.querySelectorAll('h2');

  h2Tags.forEach((h2Tag) => {
    const h2Text = h2Tag.textContent;
    if (!h2Text) return;

    const slug = slugify(h2Text);
    h2Tag.id = slug;
  });

  return new XMLSerializer().serializeToString(doc);
};

const getH2s = (rawContent: string) => {
  const doc = new DOMParser().parseFromString(
    addIdsToH2(rawContent),
    'text/html'
  );
  return Array.from(doc.querySelectorAll('h2'));
};

export const useTableOfContents = (rawContent: string) => {
  const [content, setContent] = useState<{
    content: string;
    headings2: HTMLHeadingElement[];
  }>({
    content: rawContent,
    headings2: [],
  });

  useEffect(() => {
    setContent({
      content: addIdsToH2(rawContent),
      headings2: getH2s(rawContent),
    });
  }, [rawContent]);

  return content;
};
